import { observable } from 'mobx';
import axios from 'axios'

import { apiUrl } from '../../config'

class HistoryStore {
  @observable historyList = []

  getHistory = () =>{
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userPhone = localStorage.getItem('clienInfo') ? JSON.parse(localStorage.getItem('clienInfo')) : ''
    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&func=loadHistory&phone=${userPhone.varTel}`)
      .then( response => {
        if(response.data.message === 'EmptyHistory'){
          this.historyList = []
        } else if (response.data.message === 'SuccessError'){
          this.historyList = []
        } else {          
          this.historyList = response.data
        }
      })
      .catch( err => {
        console.log(err)
      })
  }
}

export default new HistoryStore();
